import React from 'react';
import TimeSlotControl from './TimeSlotControl';
import {
  useTimeSlotSelection,
  UseTimeSlotSelectionReturn,
} from './useTimeSlotSelection';
import { PreferredServiceDay } from './timeSlotHelpers';
import './time-slot.scss';

interface TimeSlotProps {
  fromScheduling?: PreferredServiceDay[];
  onSelectionChange: (selection: string) => void;
  from?: string;
  serviceRequestForm?: boolean;
}

const TimeSlot = ({
  fromScheduling,
  onSelectionChange,
  from,
  serviceRequestForm,
}: TimeSlotProps) => {
  const timeSlotSelection: UseTimeSlotSelectionReturn = useTimeSlotSelection({
    fromScheduling,
    from,
    onSelectionChange,
  });

  return (
    <div className="time-slot">
      <div className="availability-heading">
        <div className="availability-label">Homeowner Availability</div>
        <div className="availability-required" />
      </div>
      {serviceRequestForm && (
        <div>Please indicate what days and times might work for you.</div>
      )}
      <br />
      <br />
      <div className="slot-control">
        <TimeSlotControl from={from} {...timeSlotSelection} />
      </div>
    </div>
  );
};

export default TimeSlot;